import { AsyncThunkAction } from 'actions/types'
import { supportPath } from 'components/paths'
import { push } from 'functions/router'

export const openSupportChatAction = (): AsyncThunkAction => (dispatch) => {
  return dispatch(push(supportPath))
}
